/* Rosatel · 22-sep-2026 · «Agregar +» de los complementos del carrito lateral (snippets/cart-complementos.liquid).
   Suma el producto por AJAX (/cart/add.js) sin salir del cajón y refresca el cajón + el contador del header
   con el mismo mecanismo que usa el ProductForm del theme (parámetro `sections` + updateFromCartChange). */
(function () {
  if (window.rdcComplementosBound) return;
  window.rdcComplementosBound = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function showMsg(btn, text) {
    var box = btn.closest('[data-rdc]');
    var msg = box && box.querySelector('[data-rdc-msg]');
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
    setTimeout(function () { msg.hidden = true; }, 4000);
  }

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('[data-rdc-add]');
    if (!btn) return;
    evt.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var label = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Agregando…';

    var sectionEls = ['page-header', 'cart-drawer']
      .map(function (sel) { return document.querySelector(sel); })
      .filter(function (el) { return el && el.dataset.sectionId; });

    var body = {
      items: [{ id: parseInt(btn.dataset.rdcAdd, 10), quantity: 1 }],
      sections: sectionEls.map(function (el) { return el.dataset.sectionId; }).join(','),
      sections_url: window.location.pathname
    };

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (r) {
        if (!r.ok) {
          var err = (r.data && (r.data.description || r.data.message)) || 'No se pudo agregar.';
          throw new Error(typeof err === 'string' ? err : 'No se pudo agregar.');
        }
        btn.classList.add('is-added');
        btn.textContent = 'Agregado ✓';
        var sections = r.data && r.data.sections;
        if (sections && sectionEls.length && sectionEls.every(function (el) { return sections[el.dataset.sectionId]; })) {
          sectionEls.forEach(function (el) {
            if (typeof el.updateFromCartChange === 'function') el.updateFromCartChange(sections[el.dataset.sectionId]);
          });
        } else {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }
        document.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantId: body.items[0].id }
        }));
      })
      .catch(function (e) {
        btn.removeAttribute('aria-disabled');
        btn.textContent = label;
        showMsg(btn, e && e.message ? e.message : 'No se pudo agregar. Intenta de nuevo.');
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      });
  });
})();
